module.exports = __webpack_public_path__ + "placa_td_loja_s_juros_cartoes.png?50e83218dcdad13a3f1eb65fef8d266e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_td_loja_s_juros_cartoes.png
// module id = 135
// module chunks = 0